import React from 'react';
import ShareItem from './ShareItem';
import FundOpportunity from '../models/FundOpportunity';
import { StyledInput } from './styles/StyledInputs';
import { StyledButton } from './styles/StyledButtons';
import { StyledHeading, StyledTypography } from './styles/styles';
import { CircularProgress } from '@mui/material';
import StyledModal from './styles/StyledModal';

interface LightboxManagerProps {
  visible: boolean;
  requestMessage?: boolean;
  requestShare?: boolean;
  requestAppointment?: boolean;
  fundOpportunity: FundOpportunity;
  onClose: () => void;
  sendMessage: (message: string) => void;
  sendingMessage?: boolean;
  sendMessageResult?: string;
  sendMessageError?: boolean;
}

const LightboxManager: React.FC<LightboxManagerProps> = ({
  visible,
  requestMessage,
  requestShare,
  requestAppointment,
  fundOpportunity,
  onClose,
  sendMessage,
  sendingMessage,
  sendMessageResult,
  sendMessageError,
}) => {
  const [messageDraft, setMessageDraft] = React.useState('');

  if (!visible) return null;

  // Share
  if (requestShare) {
    return (
      <StyledModal open onClose={onClose} title="Share Opportunity">
        <ShareItem modelType="FundOpportunity" model={fundOpportunity} onClose={onClose} />
      </StyledModal>
    );
  }

  // Message
  if (requestMessage) {
    return (
      <StyledModal
        open
        onClose={onClose}
        title="Send a Message"
        actions={
          !sendMessageResult && (
            <StyledButton
              disabled={sendingMessage}
              onClick={() => sendMessage(messageDraft)}
              startIcon={
                sendingMessage ? <CircularProgress size={18} color="inherit" /> : undefined
              }
            >
              {sendingMessage ? 'Sending...' : 'Send'}
            </StyledButton>
          )
        }
      >
        <StyledTypography fontWeight={600} tone="tone1" sx={{ mb: 2 }}>
          Subject:
        </StyledTypography>
        <StyledTypography tone="tone1" sx={{ mb: 2 }}>
          New Fund Query – {fundOpportunity.summaryTitle}
        </StyledTypography>

        <StyledInput
          fullWidth
          multiline
          minRows={4}
          placeholder="Write your message here..."
          value={messageDraft}
          onChange={(e) => setMessageDraft(e.target.value)}
        />

        {sendMessageResult && (
          <StyledTypography tone={sendMessageError ? 'danger' : 'tone1'} sx={{ mt: 2 }}>
            {sendMessageResult}
          </StyledTypography>
        )}
      </StyledModal>
    );
  }

  // Appointment
  if (requestAppointment) {
    return (
      <StyledModal open onClose={onClose} title="Request Appointment">
        <StyledHeading headerVariant="subheading">
          Please select a time from the calendar below:
        </StyledHeading>
        <iframe
          title="Appointment Booking"
          className="appointment-iframe"
          src={`https://calendar.google.com/calendar/appointments/schedules/${process.env.REACT_APP_CALENDAR_ID}?gv=true`}
          style={{
            border: 0,
            width: '100%',
            height: '480px',
            borderRadius: '1rem',
          }}
          frameBorder="0"
        ></iframe>
      </StyledModal>
    );
  }

  return null;
};

export default LightboxManager;
